import { createApiClient } from '../lib/apiClient';
import { useEffect, useState } from "react";
import { useUserId } from "../UserIdContext";

const api = createApiClient({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3220",
  headers: { "Content-Type": "application/json" },
});

const API = {
  PENDIENTES: "/api/egresos/pendientes",
  CONFIRMAR: "/api/egresos/confirmar",
  CANCELAR: (id) => `/api/egresos/carrito/cancelar/${id}`,
};

const Pedidos = () => {
  const { deposito } = useUserId();
  const depositoActual = deposito || "binder1";

  const [pedidos, setPedidos] = useState([]);
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);

  const [showModalEgreso, setShowModalEgreso] = useState(false);
  const [showModalResumen, setShowModalResumen] = useState(false);
  const [palletsDanioSel, setPalletsDanioSel] = useState([]);

  const [formEgreso, setFormEgreso] = useState({
    danosOut: false,
    motivoDanos: "",
    fechaEgreso: "",
    compEgreso: "",
    observacionesOut: "",
    transporte: "",
    chofer: "",
    patente: "",
  });

  const modalStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    zIndex: 1050,
  };

  const fmtFecha = (s) => {
    if (!s) return "";
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("es-AR");
  };
  const getClienteTexto = (pedido) => {
    const arr = Array.isArray(pedido?.cliente) ? pedido.cliente : [];
    if (!arr.length) return "Cliente";
    const c0 = arr[0] || {};
    return c0.nombreCliente || c0.codCliente || c0._id || "Cliente";
  };
  const getPalletKey = (item, idx) => {
    const palletId = item?.palletId?._id || item?.palletId;
    if (palletId) return `id:${palletId}`;
    if (item?.nIdentificacion) return `ident:${item.nIdentificacion}`;
    if (item?.nPallet) return `np:${item.nPallet}::${item?.numRemito || ""}`;
    return `idx:${idx}`;
  };
  const formatEstado = (estado) => {
    if (!estado) return "";
    if (estado === "Reservado") return "Pedido";
    if (estado === "Egresado") return "Realizado";
    return estado;
  };
  const actualizarPedidos = async () => {
    try {
      const response = await api.get(API.PENDIENTES, {
        params: { deposito: depositoActual },
      });
      setPedidos(response.data);
    } catch (error) {
      console.error("Error al obtener los pedidos pendientes:", error);
      alert("Ocurrió un error al obtener los pedidos pendientes");
    }
  };

  // cuando se monta el componente, actualiza los pedidos
  useEffect(() => {
    actualizarPedidos();
  }, [depositoActual]);

  const confirmarPedidoConEgreso = async () => {
    if (!pedidoSeleccionado?._id) return;
    const pallets = pedidoSeleccionado?.pedido?.[0]?.pallet || [];
    const selectedSet = new Set(palletsDanioSel);
    const palletsDanio = formEgreso.danosOut
      ? pallets
          .map((item, idx) => {
            const key = getPalletKey(item, idx);
            if (!selectedSet.has(key)) return null;
            const palletId = item?.palletId?._id || item?.palletId;
            return {
              palletId: palletId || undefined,
              nIdentificacion: item?.nIdentificacion || undefined,
              nPallet: item?.nPallet || undefined,
              numRemito: item?.numRemito || undefined,
            };
          })
          .filter(Boolean)
      : [];
    if (formEgreso.danosOut && palletsDanio.length === 0) {
      alert("Seleccione el/los pallets con dano.");
      return;
    }
    try {
      await api.post(API.CONFIRMAR, {
        egresoId: pedidoSeleccionado._id,
        deposito: depositoActual,
        danosOut: formEgreso.danosOut,
        motivoDanos: formEgreso.motivoDanos,
        fechaEgreso: formEgreso.fechaEgreso,
        compEgreso: formEgreso.compEgreso,
        observacionesOut: formEgreso.observacionesOut,
        transporte: formEgreso.transporte,
        chofer: formEgreso.chofer,
        patente: formEgreso.patente,
        palletsDanio,
      });

      alert("Pedido y egreso confirmados correctamente");
      setShowModalEgreso(false);
      setPedidoSeleccionado(null);
      setPalletsDanioSel([]);
      actualizarPedidos();
    } catch (error) {
      console.error(error);
      alert("Error al confirmar el pedido");
    }
  };

  const eliminarPedido = async () => {
    if (!pedidoSeleccionado?._id) return;
    const egresoId = pedidoSeleccionado._id;
    try {
      await api.delete(API.CANCELAR(egresoId), {
        params: { deposito: depositoActual },
      });
      alert("Pedido eliminado!");
      setPedidoSeleccionado(null);
      actualizarPedidos();
    } catch (error) {
      console.error("Error al eliminar pedido:", error);
      alert("Hubo un error al eliminar el pedido.");
    }
  };

  return (
    <>
      <div className="container my-4">
        <h2 className="text-center mb-4 text-success">
          Listado pedidos pendientes
        </h2>
        {/* filtro seleccionar cliente */}

        {pedidos && (
          <div className="table-responsive rounded-3 shadow">
            <table className="table table-sm mb-0">
              <thead className="table-success">
                <tr className="text-center">
                  <th>cliente</th>
                  <th>Fecha Reserva</th>
                  <th>cantidad palets</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {pedidos?.map((pedido) => (
                  <tr
                    key={pedido._id}
                    className="text-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPedidoSeleccionado(pedido);
                      setShowModalResumen(true);
                    }}
                  >
                    <td>{getClienteTexto(pedido)}</td>
                    <td> {fmtFecha(pedido?.fechaReserva)} </td>
                    <td> {pedido?.pedido?.[0]?.pallet?.length} </td>
                    <td>{formatEstado(pedido?.pedido?.[0]?.estado)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* NO TENER EN CUENTA ESTAS COLUMNAS
      <th>RTO</th>
      <th>Nro Factura</th>
      <th>Nombre Transporte</th>
      <th>Patente</th>
      <th>Chofer</th>
      <th>Observaciones</th> */}

      {/* modal resumen pedido */}
      {showModalResumen && (
        <div
          className="modal-bootstrap"
          style={modalStyle}
          onClick={() => setShowModalResumen(false)}
        >
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h5 className="modal-title text-success">
                    Resumen del pedido
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModalResumen(false)}
                  />
                </div>

                <div className="modal-body">
                  <table className="table table-sm">
                    <thead className="table-success">
                      <tr className="text-center">
                        <th>Nro Palet</th>
                        <th>Nro Remito</th>
                        <th>Nombre Producto</th>
                        <th>Reservado</th>
                        <th>Disponible</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pedidoSeleccionado?.pedido?.[0]?.pallet?.map(
                        (item, idx) => (
                          <tr key={idx} className="text-center">
                            <td>{item.nIdentificacion || item.nPallet || ""}</td>
                            <td>{item.numRemito || ""}</td>
                            <td>
                              {Array.isArray(item.productos)
                                ? item.productos[0]
                                : item.productos || ""}
                            </td>
                            <td>{item.cantidadReservada}</td>
                            <td>{item.cantidadDisponible}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-danger"
                    onClick={async () => {
                      await eliminarPedido();
                      setShowModalResumen(false);
                    }}
                  >
                    Eliminar Pedido
                  </button>

                  <button
                    className="btn btn-success"
                    onClick={() => {
                      setFormEgreso({
                        danosOut: false,
                        motivoDanos: "",
                        fechaEgreso: new Date().toISOString().slice(0, 10),
                        compEgreso: "",
                        observacionesOut: "",
                        transporte: "",
                        chofer: "",
                        patente: "",
                      });
                      setPalletsDanioSel([]);
                      setShowModalResumen(false);
                      setShowModalEgreso(true);
                    }}
                  >
                    Completar Pedido
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* modal completar egreso */}
      {showModalEgreso && (
        <div
          className="modal-bootstrap"
          style={{ ...modalStyle, zIndex: 1060 }}
          onClick={() => setShowModalEgreso(false)}
        >
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h5 className="modal-title text-success">
                    Completar egreso – Pedido
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModalEgreso(false)}
                  />
                </div>

                <div className="modal-body">
                  {/* Daños */}
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={formEgreso.danosOut}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setFormEgreso((prev) => ({
                          ...prev,
                          danosOut: checked,
                          motivoDanos: checked ? prev.motivoDanos : "",
                        }));
                        if (!checked) setPalletsDanioSel([]);
                      }}
                    />
                    <label className="form-check-label">
                      ¿El pedido sufrió daños?
                    </label>
                  </div>

                  {formEgreso.danosOut && (
                    <>
                      <div className="mb-3">
                        <label>Motivo de los danos</label>
                        <input
                          className="form-control"
                          value={formEgreso.motivoDanos}
                          onChange={(e) =>
                            setFormEgreso({
                              ...formEgreso,
                              motivoDanos: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="mb-3">
                        <label>Pallets con dano</label>
                        <div className="table-responsive">
                          <table className="table table-sm">
                            <thead className="table-success">
                              <tr className="text-center">
                                <th>Dano</th>
                                <th>Nro Palet</th>
                                <th>Nro Remito</th>
                                <th>Nombre Producto</th>
                              </tr>
                            </thead>
                            <tbody>
                              {pedidoSeleccionado?.pedido?.[0]?.pallet?.length ? (
                                pedidoSeleccionado.pedido[0].pallet.map(
                                  (item, idx) => {
                                    const key = getPalletKey(item, idx);
                                    const checked = palletsDanioSel.includes(key);
                                    return (
                                      <tr key={key} className="text-center">
                                        <td>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={checked}
                                            onChange={() => {
                                              setPalletsDanioSel((prev) =>
                                                prev.includes(key)
                                                  ? prev.filter((k) => k !== key)
                                                  : [...prev, key]
                                              );
                                            }}
                                          />
                                        </td>
                                        <td>
                                          {item.nIdentificacion || item.nPallet || ""}
                                        </td>
                                        <td>{item.numRemito || ""}</td>
                                        <td>
                                          {Array.isArray(item.productos)
                                            ? item.productos[0]
                                            : item.productos || ""}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No hay pallets para seleccionar.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}


                  <div className="row">
                    <div className="mb-3 col">
                      <label>Fecha de egreso</label>
                      <input
                        type="date"
                        className="form-control"
                        value={formEgreso.fechaEgreso}
                        onChange={(e) =>
                          setFormEgreso({
                            ...formEgreso,
                            fechaEgreso: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3 col">
                      <label>Comprobante de egreso</label>
                      <input
                        className="form-control"
                        value={formEgreso.compEgreso}
                        onChange={(e) =>
                          setFormEgreso({
                            ...formEgreso,
                            compEgreso: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="mb-3 col">
                      <label>Transporte</label>
                      <input
                        className="form-control"
                        value={formEgreso.transporte}
                        onChange={(e) =>
                          setFormEgreso({
                            ...formEgreso,
                            transporte: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3 col">
                      <label>Chofer</label>
                      <input
                        className="form-control"
                        value={formEgreso.chofer}
                        onChange={(e) =>
                          setFormEgreso({
                            ...formEgreso,
                            chofer: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="mb-3 col">
                      <label>Patente</label>
                      <input
                        className="form-control"
                        value={formEgreso.patente}
                        onChange={(e) =>
                          setFormEgreso({
                            ...formEgreso,
                            patente: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label>Observaciones</label>
                    <textarea
                      className="form-control"
                      value={formEgreso.observacionesOut}
                      onChange={(e) =>
                        setFormEgreso({
                          ...formEgreso,
                          observacionesOut: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModalEgreso(false)}
                  >
                    Cancelar
                  </button>

                  <button
                    className="btn btn-success"
                    onClick={confirmarPedidoConEgreso}
                  >
                    Confirmar pedido y egreso
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .modal-bootstrap{
          --panel:rgba(13,25,36,.6);
          --panel-strong:rgba(13,25,36,.88);
          --stroke:#113143;
          --text:#e9f2ff;
          --muted:#9bb6d9;
          --primary:#0A9C5E;
          --primary-700:#0C7A4C;
          --accent:#65f9a1;
        }

        .modal-bootstrap .modal{
          position: static;
          display: block;
          width: auto;
          height: auto;
          max-height: none;
          padding: 0;
          margin: 0;
          background: transparent;
          box-shadow: none;
          overflow: visible;
        }
        .modal-bootstrap .modal-content{
          background:linear-gradient(180deg, rgba(13,25,36,.96), rgba(9,18,25,.92));
          color:var(--text);
          border:1px solid var(--stroke);
          border-radius:18px;
          box-shadow:0 30px 80px rgba(0,0,0,.6);
        }
        .modal-bootstrap .modal-header,
        .modal-bootstrap .modal-footer{
          background:linear-gradient(180deg, rgba(13,25,36,.96), rgba(13,25,36,.85));
          border-color:var(--stroke);
        }
        .modal-bootstrap .modal-header{
          padding:14px 18px;
        }
        .modal-bootstrap .modal-footer{
          padding:12px 18px;
          gap:10px;
        }
        .modal-bootstrap .modal-title{
          color:#fff;
          font-weight:700;
        }
        .modal-bootstrap .text-success{
          color:var(--accent) !important;
        }
        .modal-bootstrap .btn-close{
          filter:invert(1);
          opacity:.7;
        }
        .modal-bootstrap .btn-close:hover{
          opacity:1;
        }
        .modal-bootstrap .modal-body{
          color:var(--text);
        }
        .modal-bootstrap .table{
          color:var(--text);
          margin-bottom:0;
        }
        .modal-bootstrap .table thead th{
          background:linear-gradient(180deg, rgba(13,25,36,.95), rgba(13,25,36,.85));
          color:var(--muted);
          border-bottom:1px solid var(--stroke);
        }
        .modal-bootstrap .table tbody td{
          border-color:rgba(17,49,67,.6);
          background:rgba(10,156,94,.06);
        }
        .modal-bootstrap .table tbody tr:nth-child(even) td{
          background:rgba(10,156,94,.1);
        }
        .modal-bootstrap .table tbody tr:hover td{
          background:rgba(10,156,94,.18);
        }
        .modal-bootstrap label{
          color:var(--muted);
          font-weight:600;
        }
        .modal-bootstrap .form-control,
        .modal-bootstrap .form-select{
          background:var(--panel-strong);
          color:var(--text);
          border:1px solid var(--stroke);
          border-radius:12px;
        }
        .modal-bootstrap .form-control::placeholder,
        .modal-bootstrap textarea::placeholder{
          color:rgba(233,242,255,.75);
        }
        .modal-bootstrap .form-control:focus,
        .modal-bootstrap .form-select:focus{
          border-color:#1f6a50;
          box-shadow:0 0 0 3px rgba(10,156,94,.18);
          background:rgba(13,25,36,.94);
        }
        .modal-bootstrap .form-check-input{
          background-color:var(--panel-strong);
          border-color:var(--stroke);
        }
        .modal-bootstrap .form-check-input:checked{
          background-color:var(--primary);
          border-color:var(--primary-700);
        }
        .modal-bootstrap .btn{
          display:inline-flex;
          align-items:center;
          gap:8px;
          padding:.5rem .95rem;
          border-radius:12px;
          font-weight:600;
          background:var(--panel-strong);
          color:var(--text);
          border:1px solid var(--stroke);
          box-shadow:0 8px 20px rgba(0,0,0,.35);
          transition:transform .2s ease, border-color .2s ease, box-shadow .2s ease;
        }
        .modal-bootstrap .btn:hover{
          transform:translateY(-1px);
          box-shadow:0 12px 28px rgba(0,0,0,.4);
          border-color:#25525f;
        }
        .modal-bootstrap .btn.btn-danger{
          background:linear-gradient(160deg, #d7434f, #b11f2d);
          border-color:rgba(215,67,79,.35);
          color:#fff;
        }
        .modal-bootstrap .btn.btn-success{
          background:linear-gradient(160deg, #12b885, var(--primary));
          border-color:rgba(10,156,94,.35);
          color:#fff;
        }
        .modal-bootstrap .btn.btn-secondary{
          background:linear-gradient(160deg, #223446, #1a2534);
          border-color:#2a3f55;
          color:var(--text);
        }
      `}</style>
    </>
  );
};

export default Pedidos;
